import { render, staticRenderFns } from "./editHousekeepingType.vue?vue&type=template&id=fc37ffe6"
import script from "./editHousekeepingType.vue?vue&type=script&lang=js"
export * from "./editHousekeepingType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports